import { PointOfSale } from "./PointOfSale.js";
export class SalesZone {
    id = null;
    companyId = null;
    name = null;
    description = null;
    sortOrder = 0;
    showProgressIndicator = false;
    enableCheckout = false;
    allowNotesOnIndividualDishes = false;
    checkoutNotice = null;
    orderOptionsNotice = null;
    frontpageNotice = null;
    enableOfflinePayment = false;
    enableOnlinePayment = false;
    collectCustomerName = false;
    collectBillingAddress = false;
    collectPhoneNumber = false;
    collectEmail = false;
    enableGeneralNote = false;
    enableVouchers = false;
    showRemainingStockNumbers = false;
    hideProductsWithoutStock = false;
    hidden = false;
    closed = false;
    enablePickup = true;
    enableDelivery = false;
    allowCustomPickupTime = false;
    allowDeliveryOnInvoice = false;
    enableTableService = false;
    categoryVisibilityRule = null;
    categoryVisibilityConfig = null;
    pagesVisibilityRule = null;
    pagesVisibilityConfig = null;
    storiesVisibilityRule = null;
    storiesVisibilityConfig = null;
    autoAppliedDiscounts = null;
    displayDeliveryTimeRule = null;
    displayDeliveryTimeTreshold = null;
    displayDeliveryTimeTresholdUnit = null;
    pointsOfSale = [];
    constructor(id, data) {
        this.id = id || null;
        let definedKeys = Object.keys(this).filter((key) => key != "id");
        for (let key in data) {
            let value = data[key];
            let keyIsDefinedOnInstance = definedKeys.includes(key);
            if (keyIsDefinedOnInstance) {
                if (value) {
                    //replace all firebase dates with real dates
                    if (value.seconds && value.toDate) {
                        value = value.toDate();
                    }
                }
                Object.assign(this, { [key]: value });
            }
        }
    }
    getPointOfSale(pointOfSaleId) {
        if (!pointOfSaleId) {
            return null;
        }
        if (!this.pointsOfSale) {
            return null;
        }
        let pointofsale = null;
        for (let pos of this.pointsOfSale) {
            if (pos.id == pointOfSaleId) {
                pointofsale = new PointOfSale(pos.id, pos);
                break;
            }
        }
        return pointofsale;
    }
}
